import { Alert, Button, Flex, Form, Input, Typography } from 'antd'
import { requiredRule } from '../../../../utils/rules'
import { ContentWrapper } from '../components/ContentWrapper'
import { StepProps } from '../types'

const { Title } = Typography

export const NotificationName = ({ onNext }: StepProps & {}) => {
  const name = Form.useWatch('name')

  return (
    <>
      <ContentWrapper>
        <Title className="m-0" level={5}>
          Enter the campaign name
        </Title>

        <Form.Item name="id" hidden style={{ display: 'none' }} rules={[]}>
          <Input type="hidden" />
        </Form.Item>

        <Form.Item name={'name'} rules={[requiredRule()]} noStyle>
          <Input size="large" maxLength={35} showCount />
        </Form.Item>
        <Alert
          title="The name will not be visible to app users. It is just an internal name to help you identify campaign."
          type="info"
          showIcon
          style={{ marginTop: 10 }}
        />
      </ContentWrapper>
      <Flex justify="flex-end" gap={8}>
        <Button type="primary" onClick={onNext} disabled={!name || name == ''}>
          Next
        </Button>
      </Flex>
    </>
  )
}
